import {middlewareWrapper} from "utils/middlewareUtils";
import {setBetCount, INIT, OPEN} from 'modules/Common/reducers/betslip';
import { ADD } from 'modules/Common/reducers/betlink';
import {showMenu} from 'modules/Common/reducers/menu';

export default (window, config) => {
    return [
        middlewareWrapper(init),
        middlewareWrapper(open),
        middlewareWrapper(addBet)
    ]

    function init(store, next, action) {
        if (action.type === INIT) {
            if (typeof window == 'undefined' || !window.ocRenderers)  {
                return next(action);
            }

            const { dispatch, getState } = store; 
            const betslipState = getState().common.betslip;
            if (betslipState.initialised) {
                return next(action);
            }

            const initOcBetSlip = () => {
                if (!window.ocBetslip) {                        
                    setTimeout(initOcBetSlip, 1);
                    return;
                }
    
                const setCount = () => {
                    const count = window.ocBetslip.getBetCount()
                    dispatch(setBetCount(count));
                    if (betslipState.count != count && count > 0) {
                        dispatch(showMenu());
                    }                    
                }
                setCount();
    
                window.ocBetslip.setCallbacks({
                    setBetCount: () => setCount()
                });            
    
            }            
    
            if (window.ocRenderers && window.ocRenderers['integrated-betslip']) {
                window.ocRenderers['integrated-betslip']({ 
                    apiKey: config.oddschecker.apiKey,
                    affIds: {
                      SK: config.oddschecker.affId
                    }
                }, (error) => { //handle error
                    if (!error) {
                        initOcBetSlip();
                    }                
                });
            }

        }

        return next(action);
    }

    function open(store, next, action) {
        if (action.type === OPEN && window.ocBetslip) {
            window.ocBetslip.toggle(true);
        }

        return next(action);
    }

    function addBet(store, next, action) {
      if (action.type === ADD && window.ocBetslip) {
        const {betId} = action.data;
        window.ocBetslip.addBet({
          betId: betId,
          betIdType: 'SK'
        })
      }

      return next(action);
    }
}



// WEBPACK FOOTER //
// ./modules/Common/middleware/oddsCheckerBetslip.js